import styled from "styled-components";
import { Status } from "../../models/serviceFeatures/ServiceScreenFeatureModel";

export const FiltersContainer = styled.div`
  padding: 16px;
  background-color: #f9fafb;
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const FiltersTitle = styled.h3`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

export const FilterLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const FeaturesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeaderRow = styled.tr`
  background-color: #f3f4f6;
  border-bottom: 2px solid #e5e7eb;
`;

export const TableHeaderCell = styled.th<{ textAlign?: string }>`
  padding: 12px;
  text-align: ${(props) => props.textAlign || "left"};
  font-size: 14px;
  font-weight: 600;
`;

export const TableBodyRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TableCell = styled.td<{ textAlign?: string; fontSize?: string; textTransform?: string }>`
  padding: 12px;
  font-size: ${(props) => props.fontSize || "14px"};
  text-align: ${(props) => props.textAlign || "left"};
  text-transform: ${(props) => props.textTransform || "none"};
`;

export const EmptyStateCell = styled.td`
  padding: 40px;
  text-align: center;
  color: #6b7280;
`;

export const FeatureNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ThumbnailImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
`;

export const FeatureInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FeatureName = styled.div`
  font-weight: 500;
  font-size: 14px;
`;

export const NewBadge = styled.span`
  margin-left: 8px;
  padding: 2px 8px;
  background-color: #10b981;
  color: white;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
`;

export const FeatureDescription = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
`;

export const StatusBadge = styled.span<{ status: Status }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => {
    switch (props.status) {
      case Status.Live:
        return "#d1fae5";
      case Status.Beta:
        return "#dbeafe";
      case Status.ComingSoon:
        return "#fef3c7";
      default:
        return "#fee2e2";
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case Status.Live:
        return "#065f46";
      case Status.Beta:
        return "#1e40af";
      case Status.ComingSoon:
        return "#92400e";
      default:
        return "#991b1b";
    }
  }};
`;

export const EnabledBadge = styled.span<{ enabled: boolean }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => (props.enabled ? "#d1fae5" : "#fee2e2")};
  color: ${(props) => (props.enabled ? "#065f46" : "#991b1b")};
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;

  button {
    box-sizing: border-box;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding: 16px;
`;

export const PaginationInfo = styled.div`
  font-size: 14px;
  color: #6b7280;
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
`;

export const PageNumber = styled.span`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const LoadingContainer = styled.div`
  padding: 40px;
  text-align: center;
`;

export const FeatureIdCell = styled(TableCell)`
  cursor: pointer;
  user-select: none;
  font-family: monospace;
  font-size: 12px;
  color: #6b7280;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    background-color: #f3f4f6;
    color: #374151;
  }

  &:active {
    background-color: #e5e7eb;
  }
`;

export const PotentialStatusBadge = styled.span<{ statusType: string }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${(props) => {
    switch (props.statusType) {
      case "coming soon":
        return "#fef3c7";
      case "new":
        return "#10b981";
      case "live":
        return "#d1fae5";
      default:
        return "#d1fae5";
    }
  }};
  color: ${(props) => {
    switch (props.statusType) {
      case "coming soon":
        return "#92400e";
      case "new":
        return "white";
      case "live":
        return "#065f46";
      default:
        return "#065f46";
    }
  }};
`;

